import { render, staticRenderFns } from "./voiceactive.vue?vue&type=template&id=59351498&"
import script from "./voiceactive.vue?vue&type=script&lang=js&"
export * from "./voiceactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports